"use client";

import { createToggleContext } from "@/lib/createToggleContext";

const [WebSearchProvider, useWebSearchRaw] =
  createToggleContext("webSearch");

export { WebSearchProvider };

export function useWebSearch() {
  const { webSearch, toggle, setThreadId } = useWebSearchRaw();
  return { webSearch, toggleWebSearch: toggle, setThreadId };
}
